import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { dialog } from 'app/utils';
import { auth } from 'app/services';
import { IGlobalState, IAuthState, ICredentials } from 'app/models';
import { getSession } from './selectors';

export const authenticate = createAction<IAuthState>('auth/authenticate');
export const deauthenticate = createAction('auth/deauthenticate');

export const signin = createAsyncThunk<void, ICredentials>('auth/signin', async (credentials, { dispatch }) => {
  const { data: session } = await auth.signin(credentials);
  if (!session) { dialog.toast({ severity: 'error', message: 'Invalid username or password' }); dispatch(deauthenticate()); return; }

  dispatch(authenticate({ session }));
});
export const verify = createAsyncThunk('auth/verify', async (_, { dispatch, getState }) => {
  const current = getSession(getState() as IGlobalState);
  if (!current?.refreshToken) return;

  const { data: session } = await auth.refresh(current.refreshToken);

  dispatch(session ? authenticate({ session }) : deauthenticate());
});
export const signout = createAsyncThunk('auth/signout', async (_, { dispatch, getState }) => {
  const current = getSession(getState() as IGlobalState);
  if (!current) return;

  await auth.signout();

  dispatch(deauthenticate());
});
